import { z } from 'zod';
export const IdentifierSchema = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9-]*$/, 'must be lowercase kebab-case');
export const EntityIdSchema = z.string().uuid();
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export const RepositoryRelativePathSchema = z
    .string()
    .min(1)
    .max(512)
    .refine((value) => !value.startsWith('/') && !value.startsWith('\\'), {
    message: 'must be relative to the repository',
})
    .refine((value) => !value.split(/[\\/]/).some((segment) => segment === '..' || segment === ''), {
    message: 'must not contain empty or parent-traversing segments',
});
export const PaginationSchema = z
    .object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
})
    .strict();
export const ApiErrorSchema = z
    .object({
    error: z
        .object({
        code: z.string().min(1),
        message: z.string().min(1),
        details: z.unknown().optional(),
        requestId: z.string().min(1),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=common.js.map